// Centralized test IDs for the Integrated Wellness Hub
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "global-nav",
  logo: "nav-logo",
  linkTracks: "nav-link-tracks",
  linkMethodology: "nav-link-methodology",
  linkAssessment: "nav-link-assessment",
  linkFaq: "nav-link-faq",
  ctaApply: "nav-cta-apply",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
};

export const TRACKS = {
  root: "tracks-section",
  card: (slug) => `track-card-${slug}`,
  cardCta: (slug) => `track-card-cta-${slug}`,
};

export const TRACK_PAGE = {
  root: (slug) => `track-page-${slug}`,
  applyCta: (slug) => `track-page-apply-${slug}`,
  assessmentCta: (slug) => `track-page-assessment-${slug}`,
};

export const LEAD_FORM = {
  root: "lead-form",
  inputName: "lead-form-input-name",
  inputEmail: "lead-form-input-email",
  inputPhone: "lead-form-input-phone",
  selectTrack: "lead-form-select-track",
  selectTrackTrigger: "lead-form-select-track-trigger",
  selectTrackOption: (slug) => `lead-form-track-option-${slug}`,
  inputGoal: "lead-form-input-goal",
  submit: "lead-form-submit",
  success: "lead-form-success",
  error: "lead-form-error",
};

export const ASSESSMENT = {
  root: "assessment-section",
  tabTrigger: (slug) => `assessment-tab-${slug}`,
  embedPlaceholder: (slug) => `assessment-embed-${slug}`,
  openExternal: (slug) => `assessment-open-external-${slug}`,
};

export const METHODOLOGY = {
  root: "methodology-section",
  wheelSegment: (slug) => `methodology-wheel-${slug}`,
};

export const FAQ = {
  root: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const FOOTER = {
  root: "site-footer",
  ctaApply: "footer-cta-apply",
};

export const STICKY_CTA = {
  root: "sticky-cta",
  apply: "sticky-cta-apply",
};
